import { EyeOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { EDIT_PRODUCT_PATH } from '@app/constants';

const { Text } = Typography;

interface Props {
  productId: number;
  name: string;
}

export const ProductNameCell = ({ productId, name }: Props) => (
  <Flex className="full-width" justify="space-between">
    <Text className="no-wrap-text">{name}</Text>
    <Link to={`${EDIT_PRODUCT_PATH}?id=${productId}`} target="_blank">
      <Button icon={<EyeOutlined />} />
    </Link>
  </Flex>
);
